<template>
    <div class="page noScroll">
        <div class="page-content infinite-scroll noScroll">
            <Contact :isPrivacy="true" @on-save="save" :prevData="contactItem" @reload="reload"></Contact>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import { isChinese, isLetter, checkTel, checkMail, checkPassport } from '@/utilities/tools'
    import Contact from '@/components/Contact'
    export default {
        name: 'ContactDetail',
        components: {
            Contact
        },
        data () {
            return {
                userToken: '',
                contactItem: {}
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '常用联系人')
            this.$store.dispatch('HIDE_HEADER_BAR', {isHideFooter: true})
            this.showPage()
        },
        created() {
          this.showPage()
        },
        methods: {
            reload() {
              this.showPage()
            },
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                const id = this.$route.params.id
                const userToken = this.$store.state.user.userToken
                if (!userToken && userToken.length == 0) {
                    this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
                    return
                }
                this.userToken = userToken

                const contactList = await this.getContact(userToken,1)
                this.contactItem = contactList.find(item => `${item.id}` === id)
            },
            async getContact (userName) {
                const {success, data, errMsg} = await api.user.getContactInPersonalCenter(userName)
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            getCountryArea(country){
              return country==="CN" ||
                  country === "HK" ||
                  country === "MAC" ||
                  country === "TWN";
            },
            async save (data) {
                let contact = data
                let updateFields = data.updateFields
                let isCN = this.getCountryArea(contact.country)
                if(updateFields.length === 0) {
                  this.$alert.show('没有任何修改')
                  return false
                }

                if (!contact.country) {
                    this.$alert.show('请选择国家或地区')
                    return false
                }
                // 中国验证中文姓名
                if(isCN){
                  if (!contact.chineseLastName) {
                    this.$alert.show('请输入中文名')
                    return false
                  }
                  if (!contact.chineseFirstName) {
                    this.$alert.show('请输入中文姓')
                    return false
                  }

                  if(!this.isMaskValue || updateFields.includes("ChineseLastName")) {
                    if (!isChinese(contact.chineseLastName)) {
                      this.$alert.show('请输入正确的中文姓或中文名')
                      return false
                    }
                  }
                  if(!this.isMaskValue || updateFields.includes("ChineseFirstName")) {
                    if (!isChinese(contact.chineseFirstName)) {
                      this.$alert.show('请输入正确的中文姓或中文名')
                      return false
                    }
                  }
                }

                if (!contact.pinYinLastName) {
                    this.$alert.show('请输入拼音姓')
                    return false
                }
                if (!contact.pinYinFirstName) {
                    this.$alert.show('请输入拼音名')
                    return false
                }

                if (!this.isMaskValue) {
                  if(updateFields.includes('ChineseLastName')) {
                    updateFields.push('PinYinLastName')
                  }
                  if(updateFields.includes('ChineseFirstName')) {
                    updateFields.push('PinYinFirstName')
                  }
                }

                if(!this.isMaskValue || updateFields.includes("PinYinLastName")) {
                  if (!isLetter(contact.pinYinLastName)) {
                      this.$alert.show('请输入正确的拼音姓或拼音名')
                      return false
                  }
                }
                if(!this.isMaskValue || updateFields.includes("PinYinFirstName")) {
                  if (!isLetter(contact.pinYinFirstName)) {
                    this.$alert.show('请输入正确的拼音姓或拼音名')
                    return false
                  }
                }

                if (!contact.gender) {
                    this.$alert.show('请选择性别')
                    return false
                }

                if (!contact.dateOfBirth) {
                    this.$alert.show('请输入出生日期')
                    return false
                }

                if(!this.isMaskValue || updateFields.includes("Telephone")) {
                  if (contact.telephone && contact.telephone.length > 0 && !checkTel(contact.telephone)) {
                      this.$alert.show('请输入正确的手机号码');
                      return false;
                  }
                }
                if(!this.isMaskValue || updateFields.includes("PassportNum")) {
                  if (contact.passPortNum && contact.passPortNum.length > 0 && !checkPassport(contact.passPortNum)) {
                    this.$alert.show('请输入正确的护照号');
                    return false;
                  }
                }

                if(!this.isMaskValue || updateFields.includes("Email")) {
                  if (contact.email && contact.email.length > 0 && !checkMail(contact.email)) {
                    this.$alert.show('请输入正确的邮箱');
                    return false;
                  }
                }

                // 提交信息
                await this.updateContact(contact)

                // 返回列表页
                this.$router.push('/Rccl.UserCenter/UserContact/List')
            },
            async updateContact (contact) {
                this.$loading.show()
                const {success, errMsg} = await api.user.updateContact(contact)
                if (!success) {
                    this.$alert.show(errMsg)
                }
                this.$loading.hide()
            }
        },
      computed: {
        isMaskValue() {
          return this.$store.state.page.isMaskValue;
        }
      }
    }
</script>

<style scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
    }
    .page-content{
        padding-bottom: 100px;
    }
</style>
